import { Spin } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const ButtonSecondaryLarge = ({
  type = 'button',
  id,
  title,
  disabled,
  style,
  preIcon,
  posIcon,
  onClick,
  loading = false,
  ...props
}) => {
  return (
    <button
      {...props}
      type={type}
      id={id}
      className={cn(
        'inline-flex justify-center items-center bg-fills-white border-[1px] border-solid border-outline-brand-primary text-primary-primary hover:bg-primary-primaryFill disabled:bg-fills-disable disabled:border-outline-default-disable disabled:text-black-low',
        'h-[40px] py-[10px] px-[16px] gap-[8px] text-body-large font-semibold rounded-[8px]',
        props.className
      )}
      disabled={disabled}
      style={{
        ...style,
        ...{
          paddingRight: `${preIcon ? '8px' : undefined}`,
          paddingLeft: `${posIcon ? '8px' : undefined}`,
        },
      }}
      onClick={onClick}
    >
      {posIcon && (
        <div className="flex items-center w-[24px] h-[24px] text-primary-primary disabled:text-black-low">
          {posIcon}
        </div>
      )}
      <span className="truncate text-primary-primary disabled:text-black-low">
        {title}
      </span>
      <Spin spinning={loading} size="medium" />
      {preIcon && (
        <div className="flex items-center w-[24px] h-[24px] text-primary-primary disabled:text-black-low">
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default ButtonSecondaryLarge;
